export default __webpack_public_path__ + "static/media/facebookAbout.bf671405.svg";